import types from "./app.types"
import { store, Provider } from "./app.provider"

const AppProvider = Provider, AppStore = store, AppTypes = types

export { AppProvider, AppStore, AppTypes }